import React from 'react'
import { useHistory, generatePath } from 'react-router-dom'
import { PAYMENT_METHOD_INFO } from 'constants/app-paths'
import { SETTINGS_SUBMENU } from 'constants/menu/submenus'
import { EMPTY_PAYMENT_METHOD } from 'constants/objects/payment-method'
import {
  requestPaymentMethodsList,
  requestPaymentMethodUpdate,
  requestPaymentMethodCreate,
} from 'requests/payment-methods'
import useSimpleList from 'hooks/useSimpleList'
import { ListPage } from 'templates/ListPage'
import { SideMenu } from 'components/SideMenu'
import { Form } from 'components/PaymentMethod/Form'
import { PaymentMethod } from './components/PaymentMethod'

export default function PaymentMethodsList() {
  const [paymentMethods, listState, listActions] = useSimpleList({
    requestList: requestPaymentMethodsList,
    requestCreate: requestPaymentMethodCreate,
    requestUpdate: requestPaymentMethodUpdate,
  })

  const history = useHistory()

  const onClickPaymentMethod = (paymentMethod) => {
    const path = generatePath(PAYMENT_METHOD_INFO, { id: paymentMethod.id })
    history.push(path)
  }

  const renderForm = () => (
    <Form
      paymentMethod={listState.currentItem || EMPTY_PAYMENT_METHOD}
      onCancel={() => listActions.onToggleForm(false)}
      onSave={listActions.save}
      saving={listState.saving}
      responseError={listState.responseError}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={SETTINGS_SUBMENU} />
  )

  const renderPaymentMethod = (paymentMethod) => (
    <PaymentMethod
      key={paymentMethod.id}
      paymentMethod={paymentMethod}
      onClick={onClickPaymentMethod}
    />
  )

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Formas de pagamento"
      onClickPagination={() => {}}
      pagination={listState.pagination}
      loading={listState.loading}
      showForm={listState.showForm}
      onToggleForm={listActions.onToggleForm}
      showAddButton
    >
      { paymentMethods.map(renderPaymentMethod) }
    </ListPage>
  )
}
